import { TitleBar } from './TitleBar';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ResizableChatPanel } from './ResizableChatPanel';
import { StatusBar } from './StatusBar';
import { MapView } from '@/map/MapView';
import { ChartCardOverlay } from '@/charts/ChartCardOverlay';
import { LegendOverlay } from '@/panels/LegendOverlay';

type AuthStatus =
  | { kind: 'pending' }
  | { kind: 'ok' }
  | { kind: 'error'; message: string };

export function AppShell({ auth }: { auth: AuthStatus }) {
  // TitleBar only carries useful UI in Electron (frameless window controls).
  // On the web it's a redundant header — skip it.
  const isElectron = typeof window !== 'undefined' && window.__platform__ === 'electron';
  return (
    <div className="flex h-screen w-full grow flex-col overflow-hidden bg-background text-foreground">
      {isElectron && <TitleBar />}
      <Header auth={auth} />
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main className="relative flex min-w-0 flex-1 flex-col overflow-hidden">
          <div className="relative min-h-0 flex-1">
            <MapView />
            <ChartCardOverlay />
            <LegendOverlay />
          </div>
          <StatusBar auth={auth} />
        </main>
        <ResizableChatPanel />
      </div>
    </div>
  );
}
